export default __webpack_public_path__ + "static/media/apolino-bg-desktop.feb70370.webp";